import { CircleCheck, TriangleAlert } from 'lucide-react';
import { type ReactNode } from 'react';

import { cn } from '@/lib/utils/cn';

interface FormAlertProps {
  tone?: 'danger' | 'success';
  children: ReactNode;
  className?: string;
}

/** Inline form-level feedback (announced to assistive technology). */
export function FormAlert({ tone = 'danger', children, className }: FormAlertProps) {
  const Icon = tone === 'danger' ? TriangleAlert : CircleCheck;
  return (
    <div
      role={tone === 'danger' ? 'alert' : 'status'}
      className={cn(
        'flex items-start gap-2.5 rounded-md border px-3 py-2.5 text-sm',
        tone === 'danger'
          ? 'border-danger/20 bg-danger-soft text-danger'
          : 'border-success/20 bg-success-soft text-success',
        className,
      )}
    >
      <Icon className="mt-0.5 size-4 shrink-0" aria-hidden="true" />
      <div>{children}</div>
    </div>
  );
}
